import { createContext, useCallback, useContext, useMemo, useRef, type ReactNode } from 'react';

type SalesTransactionsHubContextValue = {
  registerRefetch: (refetch: () => void) => void;
  refetchList: () => void;
};

const SalesTransactionsHubContext = createContext<SalesTransactionsHubContextValue | null>(null);

export const SalesTransactionsHubProvider = ({ children }: { children: ReactNode }) => {
  const refetchRef = useRef<(() => void) | null>(null);

  const registerRefetch = useCallback((refetch: () => void) => {
    refetchRef.current = refetch;
  }, []);

  const refetchList = useCallback(() => {
    refetchRef.current?.();
  }, []);

  const value = useMemo(
    () => ({ registerRefetch, refetchList }),
    [registerRefetch, refetchList]
  );

  return (
    <SalesTransactionsHubContext.Provider value={value}>
      {children}
    </SalesTransactionsHubContext.Provider>
  );
};

export const useSalesTransactionsHub = () => {
  const context = useContext(SalesTransactionsHubContext);
  if (!context) {
    throw new Error('useSalesTransactionsHub must be used within SalesTransactionsHubProvider');
  }
  return context;
};
